export default "__VITE_ASSET__BwFYIskV__"